import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorApex = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M15.012 4.442c-1.095-2.708-4.929-2.708-6.025 0l-3.69 9.118a3.25 3.25 0 0 0 .946 3.728l3.69 3.039a3.25 3.25 0 0 0 4.133 0l3.69-3.04a3.25 3.25 0 0 0 .947-3.727l-3.69-9.118Zm-7.415-.563c1.602-3.957 7.204-3.957 8.806 0l3.69 9.118a4.75 4.75 0 0 1-1.383 5.449l-3.69 3.039a4.75 4.75 0 0 1-6.04 0l-3.69-3.04a4.75 4.75 0 0 1-1.384-5.448l3.69-9.118Z"
    />
    <path
      fill="#F7A600"
      d="M14.083 9.481a.383.383 0 0 1 .53.034l1.703 1.786c.162.17.158.45-.014.608A6.298 6.298 0 0 1 12 13.61c-1.6 0-3.111-.6-4.301-1.7a.432.432 0 0 1-.014-.608l1.703-1.786a.384.384 0 0 1 .53-.034 3.197 3.197 0 0 0 4.165 0Zm-3.792 9.774a.3.3 0 0 1 0-.452 2.629 2.629 0 0 1 1.71-.635c.647 0 1.241.238 1.708.635a.3.3 0 0 1 0 .452A2.63 2.63 0 0 1 12 19.89a2.63 2.63 0 0 1-1.709-.635Zm-.903-.577-1.703-1.786a.432.432 0 0 1 .014-.608 6.299 6.299 0 0 1 4.301-1.7c1.6 0 3.112.6 4.302 1.7a.433.433 0 0 1 .014.608l-1.703 1.786a.384.384 0 0 1-.53.033 3.198 3.198 0 0 0-4.165 0 .376.376 0 0 1-.245.091.396.396 0 0 1-.285-.124Zm3.495-3.342a2.172 2.172 0 0 1-1.767 0c-.074-.033-.136.064-.08.124.243.265.585.43.963.43s.72-.165.963-.43c.048-.052.009-.131-.05-.131-.01 0-.02.002-.03.007Z"
    />
  </svg>
);
export default SvgTwoColorApex;
